// extracted by mini-css-extract-plugin
export default {"tooltipBlock":"style_tooltipBlock__WcDUM","header":"style_header__4b0rO","tooltipBlockContent":"style_tooltipBlockContent__iAQqt"};